var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-doc-view-component" }, [
    _c(
      "div",
      { ref: "roomDocView", staticClass: "room-doc-canvas-view", style: {} },
      [_c("div")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }